// extracted by mini-css-extract-plugin
export var card = "_5s-1";
export var container = "_5s-0";